/* eslint-disable */
import LedgerClient from './integrations/ledgerClient'
import isElectron from '../utils/isElectron'

const ipcRenderer = window.ipcRenderer

let client

export const initLedger = async useBle => {
  if (isElectron()) {
    ipcRenderer.send('init_ledger_client', 'init ledger')

    return new Promise((resolve, reject) => {
      ipcRenderer.on('init_ledger_client_success', (event, args) => {
        client = args.client
        resolve(args.client)
      })

      ipcRenderer.on('init_ledger_client_fail', (event, args) => {
        reject({ error: args })
      })
    })
  }

  if (!isElectron()) {
    client = new LedgerClient(useBle ? 'wble' : 'u2f')
    await client.init()
    return client
  }
}

export const getAddresses = async (hdPath, addressPrefix) => {
  if (isElectron()) {
    ipcRenderer.send('get_address', [hdPath, addressPrefix])

    return new Promise((resolve, reject) => {
      ipcRenderer.on('get_address_success', (event, args) => {
        resolve(args)
      })

      ipcRenderer.on('get_address_fail', (event, args) => {
        reject(args)
      })
    })
  }

  if (!isElectron()) {
    if (!client) {
      throw new Error('ledger should be init')
    }

    const addresses = await client.getAddresses(hdPath, addressPrefix)

    return addresses
  }
}

export const closeTransport = async () => {
  if (isElectron()) {
    ipcRenderer.send('close_transport')
  } else {
    if (!client) {
      throw new Error('ledger should be init')
    }
    const app = getApp()
    if (app) {
      app._transport.close()
    }
  }
}

export const showAddress = async (
  addressPrefix,
  tempHdPath,
  setAddressConfirmed,
  showAddressPanic
) => {
  if (isElectron()) {
    ipcRenderer.send('show_address', [addressPrefix, tempHdPath])

    return new Promise((resolve, reject) => {
      ipcRenderer.on('show_address_success', (event, args) => {
        if (args === 'success') {
          setAddressConfirmed()
        }
      })

      ipcRenderer.on('show_address_fail', () => {
        showAddressPanic()
      })
    })

    // if (res === 'success') {

    // } else {

    // }
  } else {
    if (!client) {
      throw new Error('ledger should be init')
    }

    client
      .showAddress(addressPrefix, tempHdPath) // ignore async
      .then(setAddressConfirmed)
      .catch(showAddressPanic)
  }
}

export const getApp = () => {
  let app
  if (isElectron()) {
    app = ipcRenderer.sendSync('get_app')
  } else {
    if (!client) {
      throw new Error('ledger should be init')
    }

    app = client.getApp()
  }

  return app
}

export const getVersion = async () => {
  let version
  if (isElectron()) {
    version = ipcRenderer.sendSync('get_version')
  } else {
    if (!client) {
      throw new Error('ledger should be init')
    }

    version = client._version
  }

  return version
}

export const getPublicKey = async hdPath => {
  ipcRenderer.send('get_public_key', [hdPath])

  return new Promise((resolve, reject) => {
    ipcRenderer.on('get_public_key_success', (event, args) => {
      resolve(args)
    })

    ipcRenderer.on('get_public_key_fail', (event, args) => {
      reject(args)
    })
  })
}

export const sign = async (signBytes, hdPath) => {
  ipcRenderer.send('sign', [signBytes, hdPath])

  return new Promise((resolve, reject) => {
    ipcRenderer.on('sign_success', (event, args) => {
      resolve(args)
    })

    ipcRenderer.on('sign_fail', (event, args) => {
      reject(args)
    })
  })
}

export default {
  initLedger,
  getAddresses,
  showAddress,
  getApp,
  getVersion,
}
